/**
 * Indicador de progreso de la reserva.
 *
 * Es una lista ordenada de verdad, no un adorno: el paso actual se marca con
 * `aria-current="step"`, que es lo que un lector de pantalla anuncia. El estado no
 * depende del color; cada paso dice si esta hecho, en curso o pendiente.
 */

export type PasoReserva = 'horario' | 'datos' | 'resumen' | 'confirmada';

const ORDEN: readonly { readonly clave: PasoReserva; readonly etiqueta: string }[] = [
  { clave: 'horario', etiqueta: 'Horario' },
  { clave: 'datos', etiqueta: 'Tus datos' },
  { clave: 'resumen', etiqueta: 'Confirmar' },
];

interface PropiedadesPasos {
  readonly actual: PasoReserva;
}

export function PasosReserva({ actual }: PropiedadesPasos): React.JSX.Element {
  const indiceActual =
    actual === 'confirmada' ? ORDEN.length : ORDEN.findIndex((p) => p.clave === actual);

  return (
    <nav aria-label="Progreso de la reserva" className="pasos">
      <ol className="pasos__lista">
        {ORDEN.map((paso, indice) => {
          const estado =
            indice < indiceActual ? 'hecho' : indice === indiceActual ? 'actual' : 'pendiente';

          return (
            <li
              aria-current={estado === 'actual' ? 'step' : undefined}
              className={`pasos__paso pasos__paso--${estado}`}
              key={paso.clave}
            >
              <span className="pasos__numero">{indice + 1}</span>
              <span className="pasos__etiqueta">{paso.etiqueta}</span>
              <span className="solo-lectores">
                {estado === 'hecho'
                  ? ' (completado)'
                  : estado === 'actual'
                    ? ' (paso actual)'
                    : ' (pendiente)'}
              </span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
